// Stub para React Native Web — AppsFlyer não roda no browser, então atribuição
// de instalação/deep link não existe aqui. Callbacks são resolvidos (não ignorados)
// para não travar promises que dependem deles (ex.: getAppsFlyerUID em getAppsFlyerId()).

const appsFlyer = {
  setCustomerUserId: (_userId: string) => {},

  onInstallConversionData: (_callback: (res: any) => void) => {},

  onDeepLink: (_callback: (res: any) => void) => {},

  initSdk: (
    _options: any,
    _onSuccess?: (result: any) => void,
    _onError?: (error: any) => void,
  ) => {},

  getAppsFlyerUID: (callback: (error: any, uid: string | null) => void) => {
    callback(null, null);
  },

  logEvent: (_eventName: string, _params?: Record<string, any>) => {},
};

export default appsFlyer;
